import React from 'react';
import { css } from '@emotion/react';
import { Button, EmptyState } from '@onward-delivery/design';
import { ArrowLeft } from '@onward-delivery/design/icons';
import TabviewCard from '../components/TabviewCard';
import BillingPage from '../pages/BillingPage';
import CommunicationsPage from '../pages/CommunicationsPage';
import DetailsPage from '../pages/DetailsPage';
import SkusPage from '../pages/SkusPage';
import SlaRequirementsPage from '../pages/SlaRequirementsPage';
import SurveysPage from '../pages/SurveysPage';
import { PROFILE_TABS } from '../constants';
import ShipperHeader from './ShipperHeader';

// Same outer gutter as the manifest page. Plain CSS, not an onward-design scope, so a tab can hold
// legacy MUI content (see TabviewCard's `scoped`).
const pageStyles = css`
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    padding: 2rem max(12.5%, 6rem);
`;

/**
 * A shipper's profile on the carrier's Shippers tab: back to the list, the shipper header, and the
 * profile tabs.
 * @param {{ partnership: Object, setup?: Object, onBack: Function, notify: Function }} props
 *   `notify` shows a snackbar message (`{ severity, message }`)
 */
const ShipperProfile = ({ partnership, setup, onBack, notify }) => {
    const pages = {
        details: { content: <DetailsPage partnership={partnership} notify={notify} /> },
        surveys: { content: <SurveysPage partnership={partnership} /> },
        communication: { content: <CommunicationsPage partnership={partnership} /> },
        // The account page's MUI SKU / Services grids, which need to sit outside the design scope.
        skus: { content: <SkusPage partnership={partnership} />, scoped: false },
        'sla-requirements': { content: <SlaRequirementsPage partnership={partnership} /> },
        billing: { content: <BillingPage partnership={partnership} /> },
    };
    const tabs = PROFILE_TABS.map((tab) => ({
        ...tab,
        content: <EmptyState className="py-16" title={`${tab.label} coming soon`} />,
        ...pages[tab.value],
    }));

    return (
        <div css={pageStyles}>
            <div className="onward-design">
                <Button variant="ghost" size="sm" onClick={onBack} className="-ml-3">
                    <ArrowLeft className="mr-1 h-4 w-4" />
                    Shipping Partners
                </Button>
            </div>
            <div className="onward-design">
                <ShipperHeader partnership={partnership} setup={setup} />
            </div>
            <TabviewCard tabs={tabs} label="Shipper profile" />
        </div>
    );
};

export default ShipperProfile;
